/**
 * @description Can be swapped with the primary gray color.
 */

const grayIron = {
  25: "#FCFCFC",
  50: "#FAFAFA",
  100: "#F4F4F5",
  200: "#E4E4E7",
  300: "#D1D1D6",
  400: "#A0A0AB",
  500: "#70707B",
  600: "#51525C",
  700: "#3F3F46",
  800: "#26272B",
  900: "#18181B",
  950: "#131316",
};

export default grayIron;
